<template>
  <div class="message-box">
    <div class="title">
      欢迎,{{userInfo.username}}
    </div>
    <div class="expire-time">
      您的会员期限截止到{{userInfo.expire_at}}，感谢您的使用和支持！
      <span class="recharge-btn" @click="onRenewalBtnClick">充值续费</span>
    </div>
    <div class="message-detail">
      <div class="connect">
        联系&隐私
      </div>
      <div class="detail-box">
        <div class="detail">
          <div class="label">用户名:</div>
          <div class="key-info">{{userInfo.username}}</div>
          <div @click="onEditContent({ type:'editUsername' })" class="edit-img"></div>
        </div>
        <div class="detail">
          <div class="label">手机号:</div>
          <div class="key-info">{{telPhone}}</div>
          <div @click="onEditContent({ type:'editPhone', parames: userInfo.phone})" class="edit-img"></div>
        </div>
        <div class="detail">
          <div class="label">密码:</div>
          <div class="key-info" v-if="userInfo.has_password">********</div>
          <div @click="onEditContent({ type:'editPassword', parames: userInfo.has_password})" class="edit-img"></div>
        </div>
        <div class="detail">
          <div class="label">邮箱:</div>
          <div @click="onEditContent({ type:'addMail'})" v-if="!userInfo.mail" class="key-info-empty">绑定邮箱</div>
          <div v-if="userInfo.mail" class="key-info">{{userInfo.mail}}</div>
          <div @click="onEditContent({ type:'addMail'})" v-if="userInfo.mail" class="edit-img"></div>
        </div>
        <div class="detail">
          <div class="label">微信:</div>
          <div v-if="!userInfo.wxid" class="key-info-empty"><a :href="redirectUri">绑定微信</a></div>
          <div v-if="userInfo.wxid" class="key-info">{{userInfo.wxid}}</div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="400px"
      >
      <div class="dialog-content" v-if="type === 'editUsername'">
        <input @focus="inputError = ''" type="text" class="dialog-input" placeholder="请输入新用户名" v-model.trim="updateUsernameInput"/>
        <div class="input-error">{{inputError}}</div>
      </div>
      <div class="dialog-content" v-if="type === 'addMail'">
        <input @focus="inputError = ''" type="text" class="dialog-input" placeholder="请输入邮箱" v-model.trim="addEmailInput"/>
        <div class="input-error">{{inputError}}</div>
      </div>

      <div class="dialog-content" v-if="type === 'editNewPhone'">
        <input @focus="inputError = ''" type="text" class="dialog-input1 dialog-input" placeholder="验证新手机号码" v-model.trim="newPhoneInput"/>
        <div class="input-error">{{inputError}}</div>
        <div class="row">
          <input @focus="inputError = ''" type="text" class="dialog-input2 dialog-input" placeholder="请输入验证码" v-model.trim="verifyNewInput"/>
          <el-button v-if="showNewPhoneCodeBtn" @click="onNewPhoneCodeClick" class="verification-code-btn">获取验证码</el-button>
          <el-button v-else class="verification-code-btn">{{time}}s</el-button>
        </div>
        <div class="input-error">{{inputError}}</div>
      </div>

      <div class="dialog-content" v-if="type === 'editOldPhone'">
        <input disabled="disabled" @focus="inputError = ''" type="text" class="dialog-input1 dialog-input" v-model.trim="oldPhoneInput"/>
        <div class="input-error">{{inputError}}</div>
        <div class="row">
          <input @focus="inputError = ''" type="text" class="dialog-input2 dialog-input" placeholder="请输入验证码" v-model.trim="verifyOldInput"/>
          <el-button v-if="showOldPhoneCodeBtn" @click="onOldPhoneCodeClick" class="verification-code-btn">获取验证码</el-button>
          <el-button v-else class="verification-code-btn">{{time}}s</el-button>
        </div>
        <div class="input-error">{{inputError}}</div>
      </div>

      <div class="dialog-content" v-if="type === 'oldPassword'">
        <input @focus="inputError = ''" type="password" class="dialog-input" placeholder="请输入原密码" v-model.trim="oldPasswordInput"/>
        <div class="input-error">{{inputError}}</div>
      </div>

      <div class="dialog-content" v-if="type === 'newPassword'">
        <input @focus="inputError = ''" type="password" class="dialog-input1 dialog-input" placeholder="请输入新密码" v-model.trim="newPasswordInput"/>
        <div class="input-error">{{inputError}}</div>
        <input @focus="inputError = ''" type="password" class="dialog-input3 dialog-input" placeholder="再次输入新密码" v-model.trim="secondNewPasswordInput"/>
      </div>

      <span slot="footer" class="row dialog-footer">
        <div><div @click="onCheckPhone" class="verify-phone-btn" v-if="type === 'oldPassword'">手机验证</div></div>
        <div>
          <el-button class="btn cancel-btn" @click="onDialogCancel">取消</el-button>
          <el-button class="btn confirm-btn" @click="onDialogConfirm">提交</el-button>
        </div>
      </span>
    </el-dialog> 
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '',
      type: '',
      updateUsernameInput: '',
      addEmailInput: '',
      newPhoneInput: '',
      verifyNewInput: '',
      time: 0,
      showNewPhoneCodeBtn: true,
      oldPhoneInput: '',
      verifyOldInput: '',
      showOldPhoneCodeBtn: true,
      oldPasswordInput: '',
      newPasswordInput: '',
      secondNewPasswordInput: '',
      inputError: '',
      beforeType: '',
      redirectUri: ''
    };
  },
  props: {
    userInfo: {
      required: true,
      default: () => {
        return {
          username: '',
          tel: '',
          password: '',
          mail: '',
          wx: ''
        };
      }
    }
  },
  computed: {
    telPhone() {
      if (this.userInfo.phone) {
        return this.userInfo.phone.replace(this.userInfo.phone.substring(3, 7), '****');
        // eslint-disable-next-line 
      } else {
        return '';
      }
    }
  },
  methods: {
    onRenewalBtnClick() {
      this.$router.push('/recharge');
    },
    onCheckPhone() {
      this.dialogTitle = '验证原手机号';
      this.type = 'editOldPhone';
      this.oldPhoneInput = this.telPhone;
      this.beforeType = 'oldPassword';
    },
    onEditContent(res) {
      this.inputError = '';
      this.beforeType = '';
      if (res.type === 'editUsername') {
        this.updateUsernameInput = '';
        this.dialogTitle = '请输入新用户名';
        this.type = 'editUsername';
        this.dialogVisible = true;
      } else if (res.type === 'addMail') {
        this.addEmailInput = '';
        this.dialogTitle = '绑定邮箱';
        this.type = 'addMail';
        this.dialogVisible = true;
      } else if (res.type === 'editPhone' && res.parames) {
        this.dialogTitle = '验证原手机号';
        this.type = 'editOldPhone';
        this.oldPhoneInput = this.telPhone;
        this.dialogVisible = true;
      } else if (res.type === 'editPhone' && !res.parames) {
        this.dialogTitle = '绑定新手机号';
        this.type = 'editNewPhone';
        this.dialogVisible = true;
      } else if (res.type === 'editPassword' && res.parames) {
        this.dialogTitle = '验证原密码';
        this.type = 'oldPassword';
        this.dialogVisible = true;
      } else if (res.type === 'editPassword' && !res.parames && !this.userInfo.phone) {
        this.dialogTitle = '绑定手机号后设置密码';
        this.type = 'editNewPhone';
        this.dialogVisible = true;
      } else if (res.type === 'editPassword' && !res.parames) {
        this.dialogTitle = '验证原手机号';
        this.type = 'editOldPhone';
        this.oldPhoneInput = this.telPhone;
        this.beforeType = 'oldPassword';
        this.dialogVisible = true;
      }
    },
    onDialogConfirm() {
      if (this.type === 'addMail') {
        if (!this.addEmailInput) {
          this.inputError = '邮箱不能为空';
          // eslint-disable-next-line
        } else if (!/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/.test(this.addEmailInput)) {
          this.inputError = '请输入正确的邮箱地址';
        } else {
          QuestionQuery.mail(this.addEmailInput).then(() => {
            this.$emit('getUserInfo');
            this.dialogVisible = false;
          },
          (err) => {
            this.inputError = err.data.message;
          });
        }
      } else if (this.type === 'editUsername') {
        if (!this.updateUsernameInput) {
          this.inputError = '用户名不能为空';
        } else if (!/^[\u4e00-\u9fa5_0-9A-Za-z_@.]{2,16}$/.test(this.updateUsernameInput)) {
          this.inputError = '用户名必须是2-16位之间的中文、字母、数字、下划线、@、.';
        } else {
          QuestionQuery.changeUsername(this.updateUsernameInput).then(() => {
            this.$emit('getUserInfo');
            this.dialogVisible = false;
          },
          (err) => {
            this.inputError = err.data.message;
          });
        }
      } else if (this.type === 'editNewPhone') {
        if (!this.newPhoneInput) {
          this.inputError = '手机号不能为空';
        } else if (!/^1[3456789]\d{9}$/.test(this.newPhoneInput)) {
          this.inputError = '手机号不正确';
        } else if (!this.verifyNewInput) {
          this.inputError = '验证码不能为空';
        } else {
          QuestionQuery.changePhone(this.newPhoneInput, this.verifyNewInput).then(() => {
            if (this.dialogTitle === '绑定手机号后设置密码') {
              this.dialogTitle = '设置新密码';
              this.type = 'newPassword';
            } else {
              this.$emit('getUserInfo');
              this.dialogVisible = false;
            }
          },
          (err) => {
            this.inputError = err.data.message;
          });
        }
      } else if (this.type === 'editOldPhone') {
        if (!this.verifyOldInput) {
          this.inputError = '验证码不能为空';
        } else {
          QuestionQuery.checkSms(this.verifyOldInput).then(() => {
            if (this.beforeType === 'oldPassword') {
              this.beforeType = 'editOldPhone';
              this.dialogTitle = '设置新密码';
              this.type = 'newPassword';
            } else {
              this.dialogTitle = '绑定新手机号';
              this.type = 'editNewPhone';
              this.verifyOldInput = '';
            }
          },
          (err) => {
            this.inputError = err.data.message;
          });
        }
      } else if (this.type === 'newPassword') {
        if (!this.newPasswordInput) {
          this.inputError = '密码不能为空';
        } else if (!/^([a-zA-Z0-9]|[._]){8,16}$/.test(this.newPasswordInput)) {
          this.inputError = '密码可以是数字,大写或者小写字母, . , _ , 8到16位';
        } else if (!this.secondNewPasswordInput) {
          this.inputError = '确认密码不能为空';
        } else if (!/^([a-zA-Z0-9]|[._]){8,16}$/.test(this.secondNewPasswordInput)) {
          this.inputError = '确认密码可以是数字,大写或者小写字母, . , _ , 8到16位';
        } else if (this.newPasswordInput !== this.secondNewPasswordInput) {
          this.inputError = '密码和确认密码不一致';
        } else {
          // eslint-disable-next-line 
          if (this.beforeType === 'oldPassword') {
            QuestionQuery.changePasswordByOrigin(this.oldPasswordInput, this.newPasswordInput).then(() => {
              this.$emit('getUserInfo');
              this.dialogVisible = false;
            },
            (err) => {
              this.inputError = err.data.message;
            });
          } else if (this.beforeType === 'editOldPhone') {
            QuestionQuery.changePasswordBySms(this.verifyOldInput, this.newPasswordInput).then(() => {
              this.$emit('getUserInfo');
              this.dialogVisible = false;
            },
            (err) => {
              this.inputError = err.data.message;
            });
          } else {
            QuestionQuery.changePasswordBySms(this.verifyNewInput, this.newPasswordInput).then(() => {
              this.$emit('getUserInfo');
              this.dialogVisible = false;
            },
            (err) => {
              this.inputError = err.data.message;
            });
          }
        }
      } else if (this.type === 'oldPassword') {
        if (!this.oldPasswordInput) {
          this.inputError = '密码不能为空';
        } else {
          QuestionQuery.checkPassword(this.oldPasswordInput).then(() => {
            this.beforeType = 'oldPassword';
            this.dialogTitle = '设置新密码';
            this.type = 'newPassword';
          },
          (err) => {
            this.inputError = err.data.message;
          });
        }
      }
    },
    onDialogCancel() {
      this.dialogVisible = false;
    },
    onNewPhoneCodeClick() {
      if (!this.newPhoneInput) {
        this.inputError = '手机号不能为空';
      } else if (!/^1[3456789]\d{9}$/.test(this.newPhoneInput)) {
        this.inputError = '手机号不正确';
      } else {
        QuestionQuery.postSms(this.newPhoneInput).then(() => {
          this.time = 60;
          this.showNewPhoneCodeBtn = false;
          this.newPhoneTimer();
        },
        (err) => {
          this.inputError = err.data.message;
        });
      }
    },
    newPhoneTimer() {
      if (this.time > 0) {
        this.time--;
        setTimeout(this.newPhoneTimer, 1000);
      } else {
        this.time = 0;
        this.showNewPhoneCodeBtn = true;
      }
    },
    newPhoneVerifyFocus() {
      this.inputError = '';
    },
    onOldPhoneCodeClick() {
      QuestionQuery.postSms(this.userInfo.phone).then(() => {
        this.time = 60;
        this.showOldPhoneCodeBtn = false;
        this.oldPhoneTimer();
      },
      (err) => {
        this.inputError = err.data.message;
      });
    },
    oldPhoneTimer() {
      if (this.time > 0) {
        this.time--;
        setTimeout(this.oldPhoneTimer, 1000);
      } else {
        this.time = 0;
        this.showOldPhoneCodeBtn = true;
      }
    },
    oldPhoneVerifyFocus() {
      this.inputError = '';
    },
    addMailInputFocus() {
      this.inputError = '';
    }
  },
  created() {
    // eslint-disable-next-line
    this.redirectUri = `https://open.weixin.qq.com/connect/qrconnect?appid=wxa9c297bd00d0ada9&redirect_uri=https%3a%2f%2fyanbaocool.com%2f%23%2fuserCenter%2fredirect%2fwechat_callback&response_type=code&scope=snsapi_login#wechat_redirect`;
    // this.redirectUri = `https://open.weixin.qq.com/connect/qrconnect?appid=wxa9c297bd00d0ada9&redirect_uri=http%3a%2f%2f10.10.25.71%3a8080%2f%23%2fuserCenter%2fredirect%2fwechat_callback&response_type=code&scope=snsapi_login#wechat_redirect`;
  }
};
</script>
<style lang="scss" scoped>
.message-box {
  .title {
    margin-bottom: 16px;
    font-size: 24px;
    font-weight: bold;
    color: #171f46;
  }
  .expire-time {
    margin-bottom: 32px;
    font-size: 14px;
    color: #747990;
    .recharge-btn {
      color: #2b76ff;
      font-weight: bold;
      cursor: pointer;
    }
  }
  .message-detail {
    .connect {
      padding: 13px 16px;
      font-size: 14px;
      font-weight: bold;
      color: #171f46;
      background-color: rgba(0, 11, 92, 0.03);
    }
    .detail-box {
      .detail {
        display: flex;
        flex-direction: row;
        padding: 13px 21px;
        border-bottom: 1px solid #f2f3f7;
        font-size: 14px;
        .label {
          width: 80px;
          color: #747990;
        }
        .key-info {
          margin-right: 16px;
          color: #171f46;
          font-weight: 500;

        }
        .key-info-empty {
          color: #2b76ff;
          font-weight: 500;
          cursor: pointer;
          a {
            color: #2b76ff;
            text-decoration: none;
          }
        }
        .edit-img {
          margin-top: 2px;
          width: 16px;
          height: 16px;
          line-height: 16px;
          background: url("../../assets/img/edit.svg") no-repeat;
          background-size: cover;
          cursor: pointer;
          &:hover {
            background: url("../../assets/img/edit-hover.svg") no-repeat;
          }
        }
      }
    }
  }
}

/deep/ {
  .dialog-content {
    position: relative;
  }
  .input-error {
    position: absolute;
    top: 40px;
    line-height: 16px;
    color: #e64c62;
    font-size: 10px;
    font-weight: 500;
  }
  .dialog-input {
    width: 352px;
    height: 40px;
    padding-left: 16px;
    margin-bottom: 20px;
    border-radius: 2px;
    border: solid 1px #e5e6ee;
    color: #171f46;
    outline: none;
    &:hover {
      border: solid 1px #999ebe;
    }

    &:focus {
      border: solid 1px #171f46;
    }
  }
  .dialog-input1 {
    margin-bottom: 16px !important;
  }
  .dialog-input3 {
    margin-bottom: 0 !important;
  }
  .dialog-input2 {
    width: 240px !important;
    margin-bottom: 0 !important;
  }
  .verification-code-btn {
    margin: 0 0 0 10px;
    height: 40px;
    width: 102px;
    padding: 0;
    border-radius: 2px;
    border: none;
    font-size: 14px;
    color: #747990;
    background-color: rgba(0, 11, 92, 0.03);
    &:hover {
      color: #747990;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #747990;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #747990;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
  }
  .el-dialog {
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    border-radius: 2px;
    border: solid 1px #f7f7fa;
    .el-dialog__header {
      padding: 24px;
      .el-dialog__title {
        font-size: 16px;
      }
    }
    .el-dialog__body {
      max-height: 300px;
      overflow: auto;
      padding: 0 24px;
    }
    .el-dialog__footer {
      padding: 24px;
    }
  }
}

.dialog-footer {
  justify-content: space-between;
  .verify-phone-btn {
    width: 88px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    color: #747990;
    background-color: rgba(0, 11, 92, 0.03);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    &:hover {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
  }
  .cancel-btn {
    width: 60px;
    color: #171f46;
    background-color: rgba(0, 11, 92, 0.03);
    &:hover {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
    background-blend-mode: normal, normal;
    }
  }
  .btn {
    height: 32px;
    padding: 0;
    border-radius: 2px;
    border: none;
    font-size: 14px;
  }
  .confirm-btn {
    width: 60px;
    color: #ffffff;
    background-color: #0055ff;
    &:hover {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
  }
}
</style>
